<template>
  <div id="what-are-credits" class="p-8">
    <div class="flex flex-col mb-2">
      <div class="flex flex-row justify-between items-center">
        <div class="text-[32px] font-semibold mb-2 text_color">What are credits?</div>
      </div>
      <div class="text-sm text_color">
        Credits give you access to verified emails and phone numbers, intent signals, AI Market Research, and more that help you connect with prospects and enhance your CRM.
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 hidden">
      <div v-for="credit in creditTypes" :key="credit.title" class="bg-white rounded-lg border border-[#ececec] p-4 flex flex-col min-h-[90px]">
        <div class="flex flex-row items-center">
          <ThemeImage :icon="credit.icon" class="w-7 h-7 mr-2" />
          <span class="font-semibold mr-2 text_color">{{ credit.title }}</span>
          <div>
            <span class="bg-[#f3e8ff] text_color text-[11px] font-semibold rounded-3xl px-2 py-0.5 ml-1 flex items-center">
              <ThemeImage :icon="credit.badgeIcon" class="w-4 h-4 mr-1" />
              {{ credit.creditPerType }}
            </span>
          </div>
        </div>
        <div class="text-sm secondary_color ml-9">{{ credit.description }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ThemeImage from '@/components/custom/ThemeImage.vue';
import { imageNames } from '@/javascript/imageConstants';

const creditTypes = [
  {
    icon: imageNames.EMAIL_PINK_ICON,
    title: 'Email',
    badgeIcon: imageNames.POKER_PINK_ICON,
    description: 'Access verified email addresses and directly connect with your leads and contacts.',
    creditPerType: '1 credit',
  },
  {
    icon: imageNames.PHONE_PINK_ICON,
    title: 'Phone numbers',
    badgeIcon: imageNames.POKER_PINK_ICON,
    description: 'Get direct-dial and mobile numbers for on-the-spot conversations.',
    creditPerType: '10 credits',
  },
  {
    icon: imageNames.SIGNAL_PINK_ICON,
    title: 'Signals',
    badgeIcon: imageNames.POKER_PINK_ICON,
    description: 'Get real-time intent signals: deanonymized website visitors, linkedin signals and more - to automate outreach when interest is high.',
    creditPerType: '10-15 credits',
  },
  {
    icon: imageNames.MARKET_RESEARCH_PINK_ICON,
    title: 'AI Market Research',
    badgeIcon: imageNames.POKER_PINK_ICON,
    description: 'Get AI-generated company & contact briefs—funding, tech stack, pain points—in seconds.',
    creditPerType: '5 credits',
  },
];

const onLearnMore = () => {
  window.open('/credits-info', '_blank');
};
</script>

<style scoped>
#what-are-credits {
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(179, 67, 203, 0.12) 0%, rgba(112, 149, 235, 0.12) 100%);
}
</style>
